import LArtwork from "@components/LArtwork";
import LBox from "@components/LBox";
import LPressable from "@components/LPressable";
import LText from "@components/LText";
import type { ViewArtistModalProps } from "@components/modals/ViewArtistModal/types";
import { getActiveTab } from "@hooks/useActiveTab";
import { BottomSheetPlainLayout } from "@utils/swmModal/components/BottomSheetPrimitives";
import AppModalSheet from "@utils/appModal/components/AppModalSheet";
import { router } from "expo-router";
import { forwardRef, useCallback } from "react";
import {
  type SheetAdapterRef,
  useBottomSheetManager,
} from "react-native-bottom-sheet-stack";

type ViewArtistModalSWMContentProps = {
  closeModal: () => void;
} & ViewArtistModalProps;

const ViewArtistModalSWM = ({
  artists,
  closeAllModals = true,
  closeModal,
}: ViewArtistModalSWMContentProps) => {
  const bottomSheetManager = useBottomSheetManager();

  const handlePress = useCallback(
    (artistId: string) => {
      if (closeAllModals) {
        bottomSheetManager.closeAll().catch(console.error);
      } else {
        closeModal();
      }

      router.push({
        pathname: `/(app)/(tabs)/${getActiveTab()}/artist/[artistId]`,
        params: { artistId },
      });
    },
    [bottomSheetManager, closeAllModals, closeModal],
  );

  return (
    <BottomSheetPlainLayout contentProps={{ gap: "s4", pb: "s3", pt: "s4" }}>
      {artists.map((artist) => (
        <LPressable
          key={artist.id}
          onPress={() => handlePress(artist.id)}
          sentryEventName="view_artist_modal_artist_press_swm"
        >
          <LBox flexDirection="row" alignItems="center" gap="s4">
            <LArtwork url={artist.image} size={48} borderRadius="max" />
            <LText color="black" variant="bodyM2m">
              {artist.name}
            </LText>
          </LBox>
        </LPressable>
      ))}
    </BottomSheetPlainLayout>
  );
};

export const ViewArtistModalSWMSheet = forwardRef<
  SheetAdapterRef,
  ViewArtistModalProps
>(function ViewArtistModalSWMSheet({ artists, closeAllModals = true }, ref) {
  return (
    <AppModalSheet ref={ref} showHandle={false}>
      {({ closeModal }) => (
        <ViewArtistModalSWM
          artists={artists}
          closeAllModals={closeAllModals}
          closeModal={closeModal}
        />
      )}
    </AppModalSheet>
  );
});

export default ViewArtistModalSWM;
